// src/api/ota-api.ts

import { otaUpdatesUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeadersForMultipart } from "../util/build-axios-authentication-headers";

export const postFirmwareUpload = async (namespace: string, formData) => {
  const url = otaUpdatesUrlEnvVar();
  const headers = {
    ...buildAxiosAuthenticationHeadersForMultipart(),
  };

  try {
    const response = await axios.post(
      `${url}/api/v1/ns/${namespace}/firmware`,
      formData,
      {
        headers: headers,
      },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      const message =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        "Failed to upload firmware. Please try again later.";

      throw new Error(message);
    } else {
      throw new Error("An unexpected error occurred while uploading firmware.");
    }
  }
};
